<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :callbackApi="$_emWorkflowTaskMixin_callbackApi"
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
// Author Shi Wenlong
// Date 2021-12-20 15:18:19

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";

export default {
    name: "sithMesStoolGrnWorkflowTaskView",
    mixins: [emWorkflowTaskMixin, workflowTaskMixins],
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        $_emWorkflowTaskMixin_callbackApi() {
            return this.$store.state.sithMesStoolGrn.baseModuleUrl + "/sithMesStoolGrn/complete-feedback";
        },
        config() {
            return {
                viewInfos: [
                    {
                        title: '采购订单信息',
                        entityName: 'sithMesStoolPo',
                        queryApi: process.env.VUE_APP_SITHMES_STOOL_URL + '/sithMesStoolPo/queryByPurchaseNumbers',
                        data: {
                            purchaseNumbers: this.$_emWorkflowTaskMixin_businessData.purchasingDocNumber,
                            purchaseItemNumbers: this.$_emWorkflowTaskMixin_businessData.purchasingDocItemNumber
                        }
                    },
                ],
                'approver1': {
                    name: '审批人1',
                    approveLabel: '是否同意',
                    withAttachment: true,
                    variables: [
                        {
                            label: '备注',
                            name: 'remark',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                        }
                    ]
                },
                'approver2': {
                    name: '审批人2',
                    approveLabel: '是否同意',
                    withAttachment: true,
                    variables: [
                        {
                            label: '备注',
                            name: 'remark',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                        }
                    ],
                },
                'approver3': {
                    name: '审批人3',
                    approveLabel: '是否同意',
                    variables: [
                        {
                            label: '备注',
                            name: 'remark',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                        }
                    ],
                },
            }
        }
    }
};
</script>